/**
 * Summarizes a multi-select id filter as the lone selection's name or a count.
 * @param ids - The selected ids
 * @param nameOf - Resolves an id to its display name, or null when unknown
 * @returns The chip summary, or null when nothing is selected
 */
export function idSelectionSummary(
  ids: string[],
  nameOf: (id: string) => string | null,
): string | null {
  if (ids.length === 0) {
    return null;
  }
  if (ids.length === 1) {
    return nameOf(ids[0]) ?? "1 selected";
  }
  return `${ids.length} selected`;
}
